import { CommonModule } from '@angular/common';

import {
    ModuleWithProviders,
    NgModule,
    Optional,
    SkipSelf
} from '@angular/core';
import { ApiUrlService } from './services/api-url.service';


@NgModule({
    declarations: [
  ], imports: [CommonModule]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
              ApiUrlService
            ]
        };
    }

}

export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
    if( parentModule ) {
        throw new Error(`${moduleName} ya ha sido cargado. Importar módulos principales solo en AppModule`);
    }
}
